import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IndexedDbService } from '../indexed-db/indexed-db.service';
import { IsDeviceOnlineService } from '../is-online/is-online.service';

export interface ILoaction {
  id: number;
  name: string;
}

export interface ICity {
  city_id: string;
  city_name: string;
  city_name_arabic: null;
  created_at: null;
  updated_at: null;
  state_id: number;
}

export interface ICoordinate {
  lat: number;
  lng: number;
}

export interface IAddress {
  road: string;
  suburb: string;
  city: string;
  province: string;
  state: string;
  'ISO3166-2-lvl4': string;
  postcode: string;
  country: string;
  country_code: string;
}

export interface ILocationResponse {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  lat: string;
  lon: string;
  class: string;
  type: string;
  place_rank: number;
  importance: number;
  addresstype: string;
  name: string;
  ILocationResponse;
  display_name: string;
  address: IAddress;
  boundingbox: string[];
}

export type ILoactionsResponse<T> = {
  status: boolean;
  message: string;
  data: (T extends 'city' ? ICity : ILoaction)[];
};

// ==========================================================

export interface IPlusCode {
  compound_code: string;
  global_code: string;
}

export interface ISouthwest {
  lat: number;
  lng: number;
}

export interface INortheast {
  lat: number;
  lng: number;
}

export interface IViewport {
  northeast: INortheast;
  southwest: ISouthwest;
}

export interface ILocation {
  lat: number;
  lng: number;
}

export interface IGeometry {
  location: ILocation;
  location_type: string;
  viewport: IViewport;
}

export interface IAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface IResult {
  address_components: IAddressComponent[];
  formatted_address: string;
  geometry: IGeometry;
  place_id: string;
  plus_code: IPlusCode;
  types: string[];
}

export interface IGeoCode {
  results: IResult[];
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(
    private http: HttpClient,
    private readonly _isOnline: IsDeviceOnlineService,
    private readonly _indexedDbService: IndexedDbService
  ) {}

  private headers: HttpHeaders = new HttpHeaders({
    'Access-Control-Allow-Headers': '*'
  });

  private geocodeAPI: string = 'https://maps.googleapis.com/maps/api/geocode/json?';
  private apiKey: string = 'AIzaSyAmA2B8tnEbUxUMKQZ03a_Fui3sXs4nHqw';

  geocodeLocation(lat: number, lng: number) {
    return this.http.get<IGeoCode>(`${this.geocodeAPI}latlng=${lat},${lng}&key=${this.apiKey}`);
  }

  getCountries() {
    return this.http
      .get<ILoactionsResponse<'country'>>(`${environment().api}/car/get/countries`)
      .pipe(
        tap((data) => {
          // console.log('data received is 457756:', data);
        })
      );
  }

  getStates(countryId: number) {
    return this.http
      .get<ILoactionsResponse<'state'>>(`${environment().api}/car/get/states/${countryId}`)
      .pipe(
        tap((data) => {
          // console.log('data received is 457756:', data);
        })
      );
  }
  getCities(statesId: number) {
    return this.http
      .get<ILoactionsResponse<'city'>>(`${environment().api}/car/get/cities/${statesId}`)
      .pipe(
        tap((data) => {
          // console.log('data received is 457756:', data);
        })
      );
  }

  getLocation({ lat, lng }: ICoordinate) {
    return this.http
      .get<ILocationResponse>(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
      )
      .pipe(
        tap((data) => {
          // console.log('data received is 457756:', data);
        })
      );
  }

  getAreas(data: any) {
    return this.http.post(`${environment().api}/car/get/location`, data);

    // return this._isOnline.networkStatus$.pipe(
    //   switchMap((status) => {
    //     switch (status) {
    //       case 'offline': {
    //         return this._indexedDbService.getAreasFromCities({
    //           cityId: data.city_id,
    //         });
    //       }
    //       case 'online': {
    //         return this.http.post(`${environment().api}/car/get/location`, data);
    //       }
    //     }
    //   })
    // );
  }
}
